import React from 'react'
import {
  NarrativeBlock as NarrativeBlockData,
  NarrativeSectionKey,
} from '@marketing-milk/interfaces'
import { ContentEditableInput } from 'components/mentions/ContentEditableInput'
import { MentionSuggestions } from 'components/mentions/MentionSuggestions'
import { SurfacePalette, type } from '../../tokens'
import { NarrativeBlock } from '../../components/NarrativeBlock'
import { SectionCard } from './SectionCard'
import { useNarrativeBlockSave } from './useNarrativeBlockSave'

interface Props {
  palette: SurfacePalette
  sectionKey: NarrativeSectionKey
  label: string
  packetID: number
  narrative: NarrativeBlockData[]
}

export const NarrativeSection = ({ palette, sectionKey, label, packetID, narrative }: Props) => {
  const {
    text,
    setText,
    setCursorPos,
    controlledCursorPos,
    setControlledCursorPos,
    mentionState,
    indicator,
    wrapperRef,
  } = useNarrativeBlockSave(packetID, sectionKey, narrative)

  const {
    isShowingSuggestions,
    filteredUsers,
    selectedIndex,
    selectUser,
    handleKeyDown: handleMentionKeyDown,
    taggedUsers,
  } = mentionState

  return (
    <SectionCard
      palette={palette}
      sectionKey={sectionKey}
      title={label}
      commentAnchor={{ type: 'section', id: `${packetID}:${sectionKey}`, label }}
    >
      <NarrativeBlock palette={palette}>
        <div ref={wrapperRef} style={{ position: 'relative' }}>
          {isShowingSuggestions && (
            <MentionSuggestions
              users={filteredUsers}
              selectedIndex={selectedIndex}
              onSelect={u => {
                const result = selectUser(u)
                if (result) {
                  setText(result.newValue)
                  setControlledCursorPos(result.newCursorPosition)
                }
              }}
            />
          )}
          <ContentEditableInput
            value={text}
            onChange={setText}
            onCursorPositionChange={setCursorPos}
            cursorPosition={controlledCursorPos}
            onKeyDown={e => {
              const result = handleMentionKeyDown(e)
              if (result && typeof result === 'object') {
                setText(result.newValue)
                setControlledCursorPos(result.newCursorPosition)
              }
            }}
            placeholder={`Write the ${label} update…`}
            taggedUsers={taggedUsers}
          />
        </div>
        <div
          style={{
            marginTop: 6,
            fontFamily: type.family.mono,
            fontSize: 11,
            color: palette.textFaint,
            minHeight: 14,
          }}
        >
          {indicator}
        </div>
      </NarrativeBlock>
    </SectionCard>
  )
}
